import css from 'styled-jsx/css';

const ImageGalleryHeadlineDesktopStyles = css`
  /* Block: Main image gallery headline component - flexible but with zoom support */
  .image-gallery-headline {
    text-align: center;
    position: relative;
    overflow: hidden;
    width: 100%;
    height: 100%;
    min-width: 300px;
    min-height: 300px;
    cursor: pointer;
  }

  /* Modifier: Overflow visible for ambient images */
  .image-gallery-headline--overflow-visible {
    overflow: visible;
  }

  /* Element: Controls container */
  .image-gallery-headline__controls {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    pointer-events: none;
  }

  .image-gallery-headline__controls :global(*) {
    pointer-events: auto;
  }

  /* Element: Media container */
  .image-gallery-headline__media {
    position: relative;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    z-index: 1;
    min-height: 665px;
  }

  /* Modifier: Video media container - maintain height with absolutely positioned children */
  .image-gallery-headline__media--video {
    min-height: 100%; /* Use parent's height as minimum */
  }

  /* Use pseudo-element to maintain container height when only absolutely positioned children exist */
  .image-gallery-headline__media--video::before {
    content: '';
    display: block;
    padding-bottom: 100%; /* Maintain 1:1 aspect ratio based on width */
    height: 0;
  }

  /* Element: Zoom container - background-based zoom strategy */
  .image-gallery-headline__zoom {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    pointer-events: none;
    z-index: 20;
    /* Background properties are set via inline styles for dynamic values */
  }

  /* Element: Preload images (hidden) */
  .image-gallery-headline__preload {
    display: none;
  }

  /* Global styles for images and videos - ensuring full container coverage */
  .image-gallery-headline :global(img) {
    width: 100% !important;
    height: 100% !important;
    object-fit: fill;
    max-width: none !important;
    max-height: none !important;
  }

  /* Specific targeting for Image component */
  .image-gallery-headline__media :global(img) {
    width: 100% !important;
    height: 100% !important;
    object-fit: fill;
  }

  /* Video components - ensure same dimensions as images */
  .image-gallery-headline :global(.video-headline) {
    width: 100% !important;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  /* YouTube video container - ensure same dimensions as images */
  .image-gallery-headline__media :global(.youtube-video) {
    width: 100% !important;
    height: 100% !important;
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }

  .image-gallery-headline__media :global(.youtube-video iframe) {
    width: 100% !important;
    height: 100% !important;
  }

  /* Accessibility improvements */
  .image-gallery-headline:focus-within {
    outline: 2px solid #007bff;
    outline-offset: 2px;
  }

  /* Loading state */
  .image-gallery-headline__media :global(.loading) {
    background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
    background-size: 200% 100%;
  }

  @keyframes loading {
    0% {
      background-position: 200% 0;
    }
    100% {
      background-position: -200% 0;
    }
  }

  /* Responsive design */
  @media (max-width: 768px) {
    .image-gallery-headline {
      min-height: 350px;
      max-height: 350px;
      max-width: 350px;
      margin-bottom: 12px;
    }

    .image-gallery-headline__zoom-image {
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
  }

  @media (max-width: 480px) {
    .image-gallery-headline {
      min-height: 280px;
      max-height: 280px;
      max-width: 280px;
    }
  }
`;

const PreloadImageStyles = css`
  .image-gallery-headline__preload {
    display: none;
  }
`;

export { ImageGalleryHeadlineDesktopStyles, PreloadImageStyles };
